import { render, staticRenderFns } from "./DocumentBlocInfo.vue?vue&type=template&id=742f2102&scoped=true&"
import script from "./DocumentBlocInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentBlocInfo.vue?vue&type=script&lang=js&"
import style0 from "./DocumentBlocInfo.vue?vue&type=style&index=0&id=742f2102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742f2102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742f2102')) {
      api.createRecord('742f2102', component.options)
    } else {
      api.reload('742f2102', component.options)
    }
    module.hot.accept("./DocumentBlocInfo.vue?vue&type=template&id=742f2102&scoped=true&", function () {
      api.rerender('742f2102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/DocumentBlocInfo.vue"
export default component.exports